module.exports = __webpack_public_path__ + "img/item6bag1.65448969.png";